module.exports = __webpack_public_path__ + "static/Travel-838ef212c344eced3dda6ebecfe24ecc.jpg";